/* eslint-disable */
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
function TableDynamic(props) {
	const {
		headers = [],
		rows = [],
		className = '',
		tableStyle = {},
		rowStyle = {},
		cellStyle = {},
        handleToggle = null,
		renderCell = null,
		emptyMessage = 'No data available',
        showRowToggle=false,
		disableEditableField= false,
		toggleHeader = ''
	} = props;

	const renderCellContent = (row, key, header, rowIndex, cellIndex) => {
		if (renderCell && typeof renderCell === 'function'&& header?.custom) {
			return renderCell(row, key, header, rowIndex, cellIndex);
		}

		let value = '';

		if (typeof row === 'object' && !Array.isArray(row)) {
			value = row[header?.id] !== undefined ? row[header?.id] : '';
		} else if (Array.isArray(row)) {
			value = row[cellIndex] !== undefined ? row[cellIndex] : '';
		}

		return value;
	};

    const handleToggleRow = (row) => {
        if(handleToggle && typeof handleToggle === 'function'){
           return  handleToggle(row);
        }
    };
	return (
		<table className='w-full overflow-auto' style={tableStyle}>
			<thead className='sticky top-0 bg-white'>
				<tr>
					{headers.map((header, index) => (
						<th
							key={index}
							style={{
								backgroundColor: header?.bgColor,
                                textAlign:'left',
                                fontSize: '14px',
							}}
						>
							{header?.colName}
						</th>
					))}
					{showRowToggle && (
						<th className='bg-white border border-white'>{toggleHeader} </th>
					)}
				</tr>
			</thead>
			<tbody>
				{rows.length === 0 ? (
					<tr>
						<td
							colSpan={headers.length}
							style={{
								textAlign: 'center', padding: '20px', fontStyle: 'italic',
							}}
						>
							{emptyMessage}
						</td>
					</tr>
				) : (
					rows.map((row, rowIndex) => (
						<tr key={rowIndex} style={rowStyle}>
							{headers.map((header, cellIndex) => {
								const key = header?.id;
								return (    
									<td

                                        key={cellIndex}
                                        style={cellStyle}
                                    >
                                        {renderCellContent(row, key, header, rowIndex, cellIndex)}
                                    </td>
								);
							})}
                            {showRowToggle && (
                                <td>
                                <div className="flex items-center space-x-2">
                      <div 
                        className={`w-12 h-6 rounded-full relative cursor-pointer transition-all duration-300 ${
                          row.active ? 'bg-green-100' : 'bg-gray-200'
                        }`}
                        onClick={() => {
							if(!disableEditableField){
								handleToggleRow(row);
							}
						}}
                      >
                        <div
                          className={`w-6 h-6 rounded-full absolute top-0 transition-all duration-300 ease-in-out flex items-center justify-content shadow-sm ${
                            row.active
                              ? 'translate-x-6 bg-green-500'
                              : 'translate-x-0 bg-red-500' 
                          }`}
                        >
                          {row.active ? (
                            <CheckCircleIcon className="w-full h-full text-white" />
                          ) : (
                            <CancelIcon className="w-full h-full text-white" />
                          )}
                        </div>
                      </div>
                    </div>
                                </td>
                            )}
						</tr>
					))
				)}
			</tbody>
		</table>
	);
}

export default TableDynamic;
